import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-subtitle',
  template: `
    <div class="pb-2 pl-8 pt-8 text-sm font-medium uppercase">
      <ng-content></ng-content>
    </div>
  `,
  standalone: false,
})
export class SidebarSubtitleComponent {}
